<template>
	<b-modal id="cancel-dispatch" :title="title" ref="modal" ok-title="Proceed" ok-variant="danger" 
		cancel-title="Close" @ok="handleOk" :cancel-disabled="disableConfirmButtons" 
		:ok-disabled="disableConfirmButtons" :no-close-on-backdrop="true">
		<loading :active.sync="isLoading" loader="spinner" color="#20A8D8" :is-full-page="false" />

		<div class="confirm-message">
			Are you sure you want to cancel
			<strong class="numFont">{{ selDispatch.dispatchNo }}</strong>
			?
		</div>
		<b-form @submit.stop.prevent="handleSubmit" novalidate>
			<b-form-group class="confirm-message" label="" description="Please indicate the reason of cancellation here"
				label-for="notes">
				<b-form-textarea name="Reason" type="text" v-model="selDispatch.cancelRemarks" maxlength="200"
					v-validate="getValidationParam(true, remarksRegex)" :rows="3" placeholder="" />
				<span v-show="errors.has('Reason')" class="help-block">
					{{ errors.first('Reason') }}
				</span>
			</b-form-group>
		</b-form>
	</b-modal>
</template>

<script>
// Utils
import { DateUtil } from '@/utils/dateutil';
import { DispatchUtil } from '@/utils/dispatchUtil';

// API
import dispatchApi from '@/api/dispatchApi';

// Others
import config from '@/config/env-constants';
import EventBus from '@/shared/event-bus';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import _ from 'lodash';

export default {
	name: 'cancel-dispatch',
	components: {
		Loading,
	},
	data() {
		return {
			selDispatch: {},
			loggedUser: this.$store.getters.loggedUser,
			// Check for loader
			isLoading: false,
		};
	},
	computed: {
		title() {
			return 'Cancel Dispatch';
		},
		disableConfirmButtons() {
			return this.isLoading;
		},
		remarksRegex() {
			return config.remarksRegex;
		},
	},
	mounted() {
		EventBus.$on('onCancelDispatch', (selDispatch) => {
			if (!_.isEmpty(selDispatch)) {
				this.selDispatch = DispatchUtil.cleanupFields(selDispatch);
			}
		});
	},
	methods: {
		getValidationParam(isRequired, regex) {
			return {
				required: isRequired,
				regex: regex,
			};
		},
		async handleOk(evt) {
			// Prevent modal from closing
			evt.preventDefault();

			// show loading indicator
			this.isLoading = true;

			let isValid = await this.$validator.validateAll();
			if (!isValid) {
				this.$toaster.warning('Please address the field/s with invalid input');
				this.isLoading = false;
				return;
			}

			// update fields
			this.selDispatch.dateCancelled = DateUtil.getCurrentTimestamp();
			this.selDispatch.cancelledBy = this.loggedUser.id;

			let dispatchNo = this.selDispatch.dispatchNo;
			try {
				let { data } = await dispatchApi.cancelDispatch(
					this.selDispatch,
					this.loggedUser.id
				);

				if (data.isSuccess) {
					this.$toaster.success(`Dispatch "${dispatchNo}" was cancelled successfully.`);
					this.$refs.modal.hide();
					EventBus.$emit('onCloseSaveDispatch', data.dispatch);
				} else {
					this.$toaster.warning(data.message);
				}

			} catch (error) {
				this.$toaster.error(`Error cancelling dispatch "${dispatchNo}". Please try again.`);
			} finally {
				// hide loading indicator
				this.isLoading = false;
			}
		},
	},
	beforeDestroy() {
		EventBus.$off('onCancelDispatch');
	},
};
</script>